var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5958_2417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5862 2.35216C13.2359 1.54338 11.6916 1.11597 10.1176 1.11548C8.80807 1.11471 7.51524 1.40952 6.3355 1.97795C5.15578 2.54638 4.1195 3.37375 3.30407 4.39841C2.48864 5.42306 1.91493 6.61856 1.62578 7.89578C1.33664 9.17301 1.3395 10.499 1.63421 11.775C1.92893 13.0509 2.50778 14.2439 3.32778 15.265C4.14764 16.2861 5.1875 17.109 6.36973 17.6722C7.55193 18.2355 8.84603 18.5247 10.1556 18.5181C11.2485 18.5128 12.3287 18.3015 13.3402 17.8975L18.0961 18.6894C18.6275 18.778 19.0619 18.2687 18.8907 17.758L17.6741 14.1265C18.3518 12.9379 18.741 11.6034 18.8064 10.231C18.8813 8.65883 18.5284 7.09578 17.7852 5.70832C17.0421 4.32086 15.9365 3.16096 14.5862 2.35216Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2228 10.7468C10.2228 10.231 10.6423 9.91462 11.3824 9.42009C12.0689 8.96139 12.431 8.36636 12.2699 7.55658C12.1088 6.74681 11.4397 6.07771 10.63 5.91664C9.35884 5.66379 8.1355 6.66775 8.1355 7.96379",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2218 13.676V14.1226",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5958_2417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.3a498b547d16253fd5258b42cc6902e2.svg";
export { ForwardRef as ReactComponent };